'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminContratsController', ['$scope', '$http', '$timeout', 'Auth', 'FilterState', function($scope, $http, $timeout, Auth, FilterState) {

  var API        = '/api/contrats-petroliers';
  var UPLOAD_API = '/api/upload/pdf/contrats-petroliers';

  var rawContrats = [];
  var allContrats = [];
  $scope.contrats        = [];
  $scope.isLoading       = true;
  $scope.showModal       = false;
  $scope.saving          = false;
  $scope.currentPage     = 1;
  $scope.itemsPerPage    = 10;
  $scope.pageSizeOptions = [10, 20, 50, 0];
  $scope.totalItems      = 0;
  $scope.totalPages      = 0;
  $scope.searchQuery     = '';
  $scope.filterType      = '';
  $scope.filterDateDebut = '';
  $scope.filterDateFin   = '';
  $scope.editingContrat  = {};
  $scope.successMsg      = '';
  $scope.errorMsg        = '';
  $scope.uploadingPdf    = false;
  $scope.dropOver        = false;

  // ── Pagination ────────────────────────────────────────────────────────────
  function paginate() {
    var size = parseInt($scope.itemsPerPage, 10);
    if (!size) {
      $scope.contrats   = allContrats;
      $scope.totalPages = 1;
    } else {
      var start = ($scope.currentPage - 1) * size;
      $scope.contrats   = allContrats.slice(start, start + size);
      $scope.totalPages = Math.ceil(allContrats.length / size) || 1;
    }
  }

  $scope.changePageSize = function() {
    $scope.currentPage = 1;
    paginate();
  };

  // ── Filtres ───────────────────────────────────────────────────────────────
  function parseDateField(d) {
    if (!d) return null;
    if (Array.isArray(d)) return new Date(d[0], d[1]-1, d[2]);
    var dt = new Date(d); return isNaN(dt.getTime()) ? null : dt;
  }
  function dateInRange(d, debut, fin) {
    if (!debut && !fin) return true;
    var dt = parseDateField(d);
    if (!dt) return !debut;
    if (debut && dt < new Date(debut)) return false;
    if (fin   && dt > new Date(fin + 'T23:59:59')) return false;
    return true;
  }
  function applyFilters() {
    var q = ($scope.searchQuery || '').toLowerCase().trim();
    var t = ($scope.filterType  || '').trim();
    allContrats = rawContrats.filter(function(c) {
      var matchQ = !q || [
        c.denomination || '',
        c.reference    || '',
        c.entreprise   || '',
        c.projet       || ''
      ].some(function(f) { return f.toLowerCase().indexOf(q) !== -1; });
      var matchT = !t || c.typeContrat === t;
      var matchD = dateInRange(c.dateSignature, $scope.filterDateDebut, $scope.filterDateFin);
      return matchQ && matchT && matchD;
    });
    $scope.totalItems  = allContrats.length;
    $scope.currentPage = 1;
    paginate();
  }
  function saveFilters() {
    FilterState.save('contrats', { q: $scope.searchQuery, type: $scope.filterType, debut: $scope.filterDateDebut, fin: $scope.filterDateFin });
  }
  (function() {
    var f = FilterState.load('contrats');
    $scope.searchQuery     = f.q     || '';
    $scope.filterType      = f.type  || '';
    $scope.filterDateDebut = f.debut || '';
    $scope.filterDateFin   = f.fin   || '';
  })();

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  // ── Chargement ────────────────────────────────────────────────────────────
  $scope.loadContrats = function() {
    $scope.isLoading = true;
    $http.get(API)
      .then(function(res) {
        rawContrats = Array.isArray(res.data) ? res.data : (res.data.content || []);
        applyFilters();
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des contrats.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() { saveFilters(); applyFilters(); }, 300);
  };

  $scope.onTypeChange = function() { saveFilters(); applyFilters(); };
  $scope.onDateChange = function() { saveFilters(); applyFilters(); };
  $scope.clearDates   = function() { $scope.filterDateDebut = ''; $scope.filterDateFin = ''; saveFilters(); applyFilters(); };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p;
    paginate();
  };

  $scope.getPages = function() {
    var pages = [], s = Math.max(1, $scope.currentPage - 2), e = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = s; i <= e; i++) pages.push(i);
    return pages;
  };

  // ── Upload PDF ────────────────────────────────────────────────────────────
  $scope.getPdfFilename = function(url) {
    if (!url) return '';
    var parts = url.split('/');
    var name  = parts[parts.length - 1];
    var idx   = name.indexOf('_');
    return idx >= 0 ? name.substring(idx + 1) : name;
  };

  function uploadFile(file) {
    if (!file) return;
    $scope.uploadingPdf = true;
    var formData = new FormData();
    formData.append('file', file);
    $http.post(UPLOAD_API, formData, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined }
    })
    .then(function(res) { $scope.editingContrat.lienReference = res.data.url; })
    .catch(function(err) {
      var msg = (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'envoi du fichier.';
      flash('errorMsg', msg);
    })
    .finally(function() { $scope.uploadingPdf = false; });
  }

  $scope.triggerFileInput = function() {
    if ($scope.editingContrat.lienReference) return;
    document.getElementById('contratPdfInput').click();
  };

  $scope.onFileSelected = function(input) {
    if (input.files && input.files[0]) {
      uploadFile(input.files[0]);
      input.value = '';
    }
  };

  $scope.handleDrop = function(event) {
    if ($scope.editingContrat.lienReference || $scope.uploadingPdf) return;
    var files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length > 0) uploadFile(files[0]);
  };

  $scope.removePdf = function($event) {
    if ($event) { $event.preventDefault(); $event.stopPropagation(); }
    $scope.editingContrat.lienReference = '';
  };

  // ── Formatage ─────────────────────────────────────────────────────────────
  $scope.formatDate = function(date) {
    if (!date) return '—';
    var d, day, month, year;
    if (Array.isArray(date)) {
      year = date[0]; month = date[1]; day = date[2];
    } else {
      d = new Date(date);
      if (isNaN(d.getTime())) return '—';
      day = d.getDate(); month = d.getMonth() + 1; year = d.getFullYear();
    }
    return (day < 10 ? '0' + day : '' + day) + '/' +
           (month < 10 ? '0' + month : '' + month) + '/' + year;
  };

  $scope.isLienUrl = function(lien) {
    return lien && (lien.indexOf('/api/') === 0 || lien.indexOf('http') === 0);
  };

  // ── Modal ─────────────────────────────────────────────────────────────────
  $scope.openModal = function(c) {
    if (c) {
      $scope.editingContrat = angular.copy(c);
      var ds = c.dateSignature;
      if (Array.isArray(ds)) {
        var y = ds[0], m = ds[1] < 10 ? '0' + ds[1] : ds[1], j = ds[2] < 10 ? '0' + ds[2] : ds[2];
        $scope.editingContrat.dateSignatureStr = y + '-' + m + '-' + j;
      } else {
        $scope.editingContrat.dateSignatureStr = ds ? ds.substring(0, 10) : '';
      }
    } else {
      $scope.editingContrat = { status: 'En vigueur', dateSignatureStr: '' };
    }
    $scope.uploadingPdf = false;
    $scope.dropOver     = false;
    $scope.showModal    = true;
  };

  $scope.closeModal = function() {
    $scope.showModal      = false;
    $scope.editingContrat = {};
    $scope.uploadingPdf   = false;
    $scope.dropOver       = false;
  };

  // ── Sauvegarde ────────────────────────────────────────────────────────────
  $scope.saveContrat = function() {
    if (!$scope.editingContrat.denomination) { flash('errorMsg', 'La dénomination est obligatoire.'); return; }
    $scope.saving = true;
    var payload = angular.copy($scope.editingContrat);
    payload.dateSignature = payload.dateSignatureStr || null;
    delete payload.dateSignatureStr;

    var isEdit = !!payload.id;
    var req = isEdit
      ? $http.put(API + '/' + payload.id, payload)
      : $http.post(API, payload);

    req.then(function() {
      $scope.closeModal();
      $scope.loadContrats();
      flash('successMsg', isEdit ? 'Contrat mis à jour.' : 'Contrat créé.');
    })
    .catch(function(err) {
      var msg = (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'enregistrement.';
      flash('errorMsg', msg);
    })
    .finally(function() { $scope.saving = false; });
  };

  // ── Suppression ───────────────────────────────────────────────────────────
  $scope.deleteContrat = function(c) {
    if (!confirm('Supprimer "' + c.denomination + '" ?')) return;
    $http.delete(API + '/' + c.id)
      .then(function() { $scope.loadContrats(); flash('successMsg', 'Contrat supprimé.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  // ── Export ────────────────────────────────────────────────────────────────
  $scope.showExportMenu = false;
  $scope.toggleExportMenu = function($event) { $event.stopPropagation(); $scope.showExportMenu = !$scope.showExportMenu; };
  var _hideMenu = function() { $scope.$applyAsync(function() { $scope.showExportMenu = false; $scope.showColPicker = false; }); };
  document.addEventListener('click', _hideMenu);
  $scope.$on('$destroy', function() { document.removeEventListener('click', _hideMenu); });

  // ── Sélection de colonnes ────────────────────────────────────────────────
  $scope.showColPicker = false;
  $scope.toggleColPicker = function($event) {
    $event.stopPropagation();
    $scope.showColPicker = !$scope.showColPicker;
    $scope.showExportMenu = false;
  };
  $scope.col = { reference: true, type: true, dateSignature: true, statut: true };

  var COL_DEFS = [
    { key: 'denomination',  label: 'Dénomination',      fn: function(c){ return c.denomination||''; } },
    { key: 'reference',     label: 'Référence',         fn: function(c){ return c.reference||''; } },
    { key: 'type',          label: 'Type de contrat', fn: function(c){ return c.typeContrat||''; } },
    { key: 'dateSignature', label: 'Date de signature', fn: function(c){ return $scope.formatDate(c.dateSignature); } },
    { key: 'statut',        label: 'Statut',           fn: function(c){ return c.status||''; } }
  ];

  function visibleDefs() {
    return COL_DEFS.filter(function(d) { return d.key === 'denomination' || $scope.col[d.key]; });
  }
  function getExportRows() {
    var defs = visibleDefs();
    return allContrats.map(function(c) { return defs.map(function(d){ return d.fn(c); }); });
  }
  function getExportHeaders() { return visibleDefs().map(function(d){ return d.label; }); }
  function escHtml(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function triggerDl(blob, name) {
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); document.body.removeChild(a);
    $timeout(function() { URL.revokeObjectURL(url); }, 500);
  }
  $scope.exportCSV = function() {
    $scope.showExportMenu = false;
    var rows = getExportRows().map(function(r) { return r.map(function(v) { return '"'+String(v).replace(/"/g,'""')+'"'; }).join(';'); });
    triggerDl(new Blob(['﻿'+getExportHeaders().join(';')+'\n'+rows.join('\n')], {type:'text/csv;charset=utf-8;'}), 'contrats-petroliers.csv');
  };
  $scope.exportExcel = function() {
    $scope.showExportMenu = false;
    var cell='border:1px solid #b0bec5;padding:6px 10px;font-size:11pt;font-family:Calibri,Arial,sans-serif;vertical-align:middle;', rows=getExportRows();
    var html='<html><head><meta charset="utf-8"/></head><body><table style="border-collapse:collapse">';
    var hdrs = getExportHeaders();
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#0f2544;color:#fff;font-size:14pt;font-weight:bold;text-align:center;padding:12px;">Contrats Pétroliers</td></tr>';
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#e8edf5;color:#555;font-size:9pt;text-align:center;">Exporté le '+new Date().toLocaleDateString('fr-FR')+' — '+rows.length+' entrée(s)</td></tr>';
    html+='<tr>'+hdrs.map(function(h){return'<th style="'+cell+'background:#1e3a5f;color:#fff;font-weight:bold;">'+h+'</th>';}).join('')+'</tr>';
    rows.forEach(function(r,i){var bg=i%2===0?'#f0f4fa':'#fff';html+='<tr>'+r.map(function(v){return'<td style="'+cell+'background:'+bg+';">'+escHtml(v)+'</td>';}).join('')+'</tr>';});
    html+='</table></body></html>';
    triggerDl(new Blob(['\uFEFF'+html],{type:'application/vnd.ms-excel;charset=utf-8;'}), 'contrats-petroliers.xls');
  };

  // ── Init ──────────────────────────────────────────────────────────────────
  $scope.loadContrats();
}]);
